<template>
    <div>
        <div class="spark-screen container">
            <div class="row">
                <div class="col-md-2 spark-settings-tabs">
                    <aside>
                        <ul class="nav flex-column mb-4 ">
                            <li class="nav-item">
                                <a class="nav-link active" href="#newfile" aria-controls="newfile" role="tab" data-toggle="tab">
                                    <div @click="changeTab('new_file')">
                                        New Project
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#pipeline" aria-controls="pipeline" role="tab" data-toggle="tab">
                                    <div @click="changeTab('pipeline')">
                                        Pipeline
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#contract" aria-controls="contract" role="tab" data-toggle="tab">
                                    <div @click="changeTab('contract')">
                                        Contract
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#dead" aria-controls="dead" role="tab" data-toggle="tab">
                                    <div @click="changeTab('dead')">
                                        Dead
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </aside>
                </div>

                <div class=" col-md-10 tab-content">
                    <div class="col-md-12 active tab-pane" role="tabcard" id="newfile">
                        <div v-if="currentTab === 'new_file'">
                            <form_required_fields :currentTab="'new_file'" :field-labels="fieldLabels" :labels="labels" :custom-fields-lables="customFieldsLables" :recordDetailCustomFieldLabels="recordDetailCustomFieldLabels" :recordDetailFieldLabels="recordDetailFieldLabels" :recordDetailLabels="recordDetailLabels"></form_required_fields>
                        </div>
                    </div>
                    <div class="col-md-12 tab-pane" role="tabcard" id="pipeline">
                        <div v-if="currentTab === 'pipeline'">
                            <form_required_fields :currentTab="'pipeline'" :field-labels="fieldLabels" :labels="labels" :custom-fields-lables="customFieldsLables" :recordDetailCustomFieldLabels="recordDetailCustomFieldLabels" :recordDetailFieldLabels="recordDetailFieldLabels" :recordDetailLabels="recordDetailLabels"></form_required_fields>
                        </div>
                    </div>
                    <div class="col-md-12 tab-pane" role="tabcard" id="contract">
                        <div v-if="currentTab === 'contract'">
                            <form_required_fields :currentTab="'contract'" :field-labels="fieldLabels" :labels="labels" :custom-fields-lables="customFieldsLables" :recordDetailCustomFieldLabels="recordDetailCustomFieldLabels" :recordDetailFieldLabels="recordDetailFieldLabels" :recordDetailLabels="recordDetailLabels"></form_required_fields>
                        </div>
                    </div>
                    <div class="col-md-12 tab-pane" role="tabcard" id="dead">
                        <div v-if="currentTab === 'dead'">
                            <form_required_fields :currentTab="'dead'" :field-labels="fieldLabels" :labels="labels" :custom-fields-lables="customFieldsLables" :recordDetailCustomFieldLabels="recordDetailCustomFieldLabels" :recordDetailFieldLabels="recordDetailFieldLabels" :recordDetailLabels="recordDetailLabels"></form_required_fields>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Form from "../../../utils/form";
import Datepicker from "vuejs-datepicker";
import Multiselect from 'vue-multiselect';
import {CurrencyInput} from "vue-currency-input";

export default {
    name: "project-required-fields",
    props:['fieldLabels', 'recordDetailFieldLabels'],
    data() {
        return {
            selects: {},
            labels: [],
            customFieldsLables: [],
            form: new Form({
                relate_and_connect_id: '',
                rules_of_engagement_id: '',
                find_problems_id: '',
                money_step_id: '',
                decision_process_id: '',
                sales_status_id: '',
                marketing_status_id: '',
                pre_bid: '',
                bid_date: '',
                lead_from_id: '',
                estimator_id: '',
                account_manager_id: '',
                take_off_person_id: '',
                products_and_services_id: '',
                client_profile_id: '',
                contract_type_id: '',
                office_id: '',
                sales_behaviors: [],
            }),
            currentTab: 'new_file',
            recordDetailCustomFieldLabels: [],
            recordDetailLabels: []
        };
    },
    components: {
        Datepicker,Multiselect, CurrencyInput
    },
    created() {
        this.fetchSalesBehaviors();
        this.fetchFieldsLabels();
        this.fetchRecordDetailFieldsLabels();
        this.fetchProjectCustomFields();
        this.fetchRecordDetailCustomFields();
    },
    mounted(){

    },
    methods: {
        fetchSalesBehaviors() {
            let self = this;
            axios.get(route('project.sales-behaviors')).then(({data}) => {
                self.form.sales_behaviors = data.data;
            });
        },
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                if (this.reference) {
                    let ss = _.find(data.sales_status, {code: 'Pending'});
                    if (ss) this.form.sales_status_id = ss.id;
                }
            });
        },
        changeTab(tab) {
            console.log(tab)
            this.currentTab = tab;
        },
        fetchFieldsLabels() {
            axios.get(route('api.settings.project-data-fields-labels'))
                .then((data) => {
                    let response = data.data.fieldLabels;
                    if(response) {
                        this.labels = JSON.parse(response.labels).sort((a,b) => a.label_order - b.label_order);
                    }
                });
        },
        fetchProjectCustomFields(){
            axios.get(route('api.project-custom-field.index'))
                .then((data) => {
                    this.customFieldsLables = [];
                    this.customFieldsLables = data.data.data.sort((a,b) => a.label_order - b.label_order);
                });
        },
        fetchRecordDetailCustomFields() {
            axios.get(route('api.record-detail-custom-field.index'))
                .then((data) => {
                    this.recordDetailCustomFieldLabels = [];
                    this.recordDetailCustomFieldLabels = data.data.data.sort((a,b) => a.label_order - b.label_order);
                });
        },
        fetchRecordDetailFieldsLabels() {
            axios.get(route('api.settings.record-detail-field-labels'))
                .then((data) => {
                    let response = data.data.fieldLabels;
                    if(response) {
                        this.recordDetailLabels = JSON.parse(response.labels).sort((a,b) => a.label_order - b.label_order);
                    }
                });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#raw_output {
    width: 100%;
    padding: 64px;
    margin: 32px 0;
    border: 1px solid #c1c6d1;
    border-radius: 4px;
    font-family: "Courier New", monospace;
    background-color: #3c4151;
    color: #fff;
    height: 200px;
}
</style>
